import { metrics as rumMetrics } from '@mc/rum'
import { track } from '@mc/track-event'

export const trackCoreWebVitals = () => {
  if (typeof window !== 'undefined' && window) {
    const oldCWVTracking = window?._mc?.cwvV2 !== true
    if (oldCWVTracking) {
      return
    }

    rumMetrics('Core Web Vital', (metric) =>
      track('Core Web Vital', {
        ...metric,
        measurement_type: 'onload', // cwv_reporting_onload flag enabled
        path: window?.location?.pathname,
      }),
    )
  }
}
